export const bubbleOptions = [
    {
        textureURL: `${window.assets_url}/images/raising-health/bubble_3_2.png`,
        x: 500,
        y: 250,
        xPercent: 85,
        yPercent: 15,
        speed: 0.25,
        deformX: 0.01,
        deformY: 0.01,
        deformDelta: 700
    },

    {
        textureURL: `${window.assets_url}/images/raising-health/bubble_4_1.png`,
        x: 100,
        y: 100,
        xPercent: 26,
        yPercent: 50,
        speed: 0.2,
        deformX: 0.015,
        deformY: 0.015,
        deformDelta: 100
    },
    {
        textureURL: `${window.assets_url}/images/raising-health/bubble_4_2.png`,
        x: 500,
        y: 250,
        xPercent: 68,
        yPercent: 80,
        speed: 0.3,
        deformX: 0.01,
        deformY: 0.01,
        deformDelta: 0
    },
    {
        textureURL: `${window.assets_url}/images/raising-health/bubble_3_1.png`,
        x: 100,
        y: 100,
        xPercent: 42,
        yPercent: 20,
        speed: 0.35,
        deformX: 0.013,
        deformY: 0.013,
        deformDelta: 400
    },
];
